import { z } from 'zod'
import type { Role } from '#/domain/role/Role'

export const RoleDtoSchema = z
  .object({
    Id: z.string(),
    Name: z.string(),
    Description: z.string(),
  })
  .transform((raw): Role => ({
    Id: raw.Id,
    Name: raw.Name,
    Description: raw.Description,
  }))

export type RoleResponseDto = z.input<typeof RoleDtoSchema>

export function toDomain(raw: RoleResponseDto): Role {
  return RoleDtoSchema.parse(raw)
}

export function toDomainList(raw: RoleResponseDto[]): Role[] {
  return raw.map(toDomain)
}
